"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const renames_1 = require("../../utilities/renames");
const formatDate_1 = __importDefault(require("../../utilities/formatDate"));
class PortfolioServiceImpl {
    portfolioRepository;
    mathCalculation;
    fundMinimumWithdraw = {
        SERIES_B: 8,
        SERIES_A: 100,
        SERIES_I: 100,
        NO_SERIES: 8,
        SERIES_O: 10,
    };
    minimumAmount = {
        SERIES_B: 8,
        SERIES_A: 90000,
        SERIES_I: 900000,
        NO_SERIES: 8,
        SERIES_O: 10,
    };
    constructor(portfolioRepository, mathCalculation) {
        this.portfolioRepository = portfolioRepository;
        this.mathCalculation = mathCalculation;
    }
    async findByCustomer(customer) {
        const response = await this.portfolioRepository.findByCustomer(customer);
        return response.map((portfolio) => ({
            ...portfolio,
            funds: portfolio.funds
                .filter(({ costBasis }) => costBasis)
                .map((fund) => ({
                ...fund,
                name: (0, renames_1.getFundName)(fund?.id),
                seriesName: (0, renames_1.getSeriesName)(fund?.series),
                formattedCreationDate: (0, formatDate_1.default)(fund?.creationDate),
                sharePrice: Number(fund.sharePrice),
                availableBalance: {
                    ...fund?.availableBalance,
                    amount: Number(fund?.availableBalance?.amount),
                    shares: Number(fund?.availableBalance?.shares),
                },
                balance: {
                    ...fund?.availableBalance,
                    shares: Number(fund.balance.shares),
                    amount: Number(fund.balance.amount),
                },
            })),
        }));
    }
    async findBySeries(customer) {
        const response = await this.portfolioRepository.findByCustomer(customer);
        let allFunds = [];
        const structureFunds = response.map((portfolio) => {
            return portfolio.funds
                .filter(({ costBasis }) => costBasis)
                .map((fund) => {
                const minimumAmountSerie = this.minimumAmount[fund.series];
                return {
                    id: fund.id,
                    name: (0, renames_1.getFundName)(fund?.id),
                    series: fund.series,
                    seriesName: (0, renames_1.getSeriesName)(fund?.series),
                    minimumAmount: minimumAmountSerie,
                    costBasis: fund?.costBasis,
                    sharePrice: fund?.sharePrice,
                    availableShares: fund?.balance?.shares || 0,
                    maximumAmountForRescue: fund?.availableBalance?.amount ?? 0,
                    maximumSharesForRescue: fund?.availableBalance?.shares ?? 0,
                    minimumAmountForRescue: this.fundMinimumWithdraw[fund.series],
                    amountTotal: fund?.balance?.amount || 0,
                    sharesTotal: fund?.balance?.shares || 0,
                    currency: fund?.balance.currency,
                    returns: fund?.returns,
                };
            });
        });
        allFunds = structureFunds.flat();
        return allFunds;
    }
    async findPortfolioHistory(portfolioId) {
        const response = await this.portfolioRepository.findPortfolioHistory(portfolioId);
        return response.map((data) => ({
            ...data,
            formattedDate: (0, formatDate_1.default)(data?.date),
        }));
    }
}
exports.default = PortfolioServiceImpl;
//# sourceMappingURL=PortfolioServiceImpl.js.map